/** Shared craft state helpers (client + server safe). */
export function filterKnownCraftBlocks(
  state: Record<string, unknown>,
  knownNames: Set<string>,
): Record<string, unknown> {
  const filtered: Record<string, unknown> = {};
  for (const [id, node] of Object.entries(state)) {
    const n = node as { type?: { resolvedName?: string } };
    const name = n.type?.resolvedName;
    if (id === "ROOT" || (name && knownNames.has(name))) {
      filtered[id] = node;
    }
  }
  return filtered;
}
